import React, { Suspense, ExoticComponent } from "react";

const Loadable = (Component: ExoticComponent) => (props: JSX.IntrinsicAttributes) => (
  <Suspense fallback={<>Loading</>}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
